import ParcelexApi from '../../services/parcelex';

const routeBase = 'onboarding/v3/';

export default {
  getOnboarding({ userId, onboardingId }) {
    const query = new URLSearchParams({
      userId,
      onboardingId,
    }).toString();

    return ParcelexApi.get(`${routeBase}?${query}`);
  },
  sendImage({ onboardingId, step, imageB64, extraData }) {
    return ParcelexApi
      .post(`${routeBase}${onboardingId}/${step.toLowerCase()}/send`, {
        base64Img: imageB64,
        ...extraData,
        onboardingId,
      });
  },
  resendConfirmation({ onboardingId, type }) {
    return ParcelexApi.post(`${routeBase}${onboardingId}/confirmation/resend`, {
      type,
      onboardingId,
    });
  },
  sendConfirmation({ onboardingId, securityCode }) {
    return ParcelexApi.post(`${routeBase}${onboardingId}/confirmation/send`, {
      securityCode,
      onboardingId,
    });
  },
  sendExpirationDate({ onboardingId, dueDay, userId }) {
    return ParcelexApi.post(`${routeBase}${onboardingId}/expiration`, {
      dueDay,
      userId,
      onboardingId,
    });
  },
  sendContractConfirmation({ onboardingId, userId }) {
    return ParcelexApi.post(`${routeBase}${onboardingId}/agreement`, {
      userId,
      onboardingId,
    });
  },
};
